
import { defineComponent, PropType } from 'vue';

export default defineComponent({
    name: 'ProductLineItem',
    props: {
        product: {
            type: Object as PropType<any>,
            required: true,
        },
    },
});
